import { Component } from '@angular/core';

import { POIType } from '../core/poi';
import { PointOfInterestCollector } from './poi-collector';
import { StopCollector } from './stop-collector';
import { RailCollector } from './rail-collector';

@Component({
    selector: 'legend-panel',
    templateUrl: './legend-panel.component.html',
    styleUrls: ['./legend-panel.component.scss']
})
export class LegendPanelComponent {
    filters = [
        {
            id: 'stops',
            name: 'Остановки',
            isChecked: true,
            svg: './assets/stop.svg'
        },
        {
            id: POIType.Mall,
            name: 'Торговые центры',
            isChecked: true,
            svg: './assets/mall.svg'
        },
        {
            id: POIType.SubwayStation,
            name: 'Станции метро',
            isChecked: true,
            svg: './assets/metro.svg'
        },
        {
            id: POIType.RailwayStation,
            name: 'Вокзалы',
            isChecked: true,
            svg: './assets/railway.svg'
        },
        {
            id: POIType.Hospital,
            name: 'Социальные объекты',
            isChecked: true,
            svg: './assets/hospital.svg'
        },
        {
            id: POIType.Cafe,
            name: 'Развлечения',
            isChecked: true,
            svg: './assets/cafe.svg'
        }
    ];

    constructor(
        private collector: PointOfInterestCollector,
        private stopCollector: StopCollector,
        private railCollector: RailCollector) { }

    toggle(filter: any) {
        filter.isChecked = !filter.isChecked;

        if (filter.id === 'stops') {
            if (filter.isChecked) {
                this.stopCollector.enable();
                this.railCollector.enable();
            }
            else {
                this.stopCollector.disable();
                this.railCollector.disable();
            }
            return;
        }

        if (filter.isChecked)
            this.collector.enable(filter.id as POIType);
        else
            this.collector.disable(filter.id as POIType);
    }
}


// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/common/legend-panel.component.ts